import React from "react";
import { Capacitor } from "@capacitor/core";
import "./IncomingCallOverlay.css";
import { useCallSession } from "../context/CallSessionContext";

export default function GlobalIncomingCallOverlay() {
  const callSession = useCallSession();

  if (!callSession) return null;

  const {
    state: { incomingCall, incomingCallId, inCall, isCalling },
    actions: { acceptCall, declineCall },
    refs,
  } = callSession;

  if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === "ios") {
    return null;
  }

  // If no incoming call OR we're already in a call -> hide overlay
  if (!incomingCall || !incomingCallId || inCall || isCalling) return null;

  const name =
    incomingCall.fromUserName ||
    incomingCall.fromName ||
    "Unknown Caller";

  const agency =
    incomingCall.fromAgency ||
    incomingCall.agency ||
    "Unknown Agency";

  const handleAccept = () => {
    acceptCall();
    const audio = refs?.remoteAudioRef?.current;
    if (audio) {
      audio.play().catch(() => {});
    }
  };

  return (
    <div className="incoming-call-overlay">
      <div className="incoming-call-container">
        <div className="incoming-call-title">Incoming Call</div>

        <div
          style={{
            fontSize: "1.6rem",
            fontWeight: "bold",
            marginBottom: "8px",
          }}
        >
          {name}
        </div>

        <div
          style={{
            fontSize: "1.2rem",
            marginBottom: "20px",
            opacity: 0.8,
          }}
        >
          {agency}
        </div>

        <div className="incoming-call-actions">
          <button
            className="decline-button"
            onClick={() => declineCall()}
          >
            Decline
          </button>

          <button
            className="accept-button"
            onClick={handleAccept}
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
